<template>
  <div id="cases">
    <TabBar />
    <div class="cases_banner"></div>
    <div class="container">
      <div class="home_item">
        <div class="container cases_flex">
          <div class="home_item_content">
            <h6>Successful cases</h6>
            <i></i>
            <h1>成功案例</h1>
          </div>
          <!-- <ul class="cases_sort">
            <li>
              <a href>全部</a>
            </li>
            <li>
              <a href>手机端</a>
            </li>
            <li>
              <a href>web端</a>
            </li>
            <li>
              <a href>智能硬件</a>
            </li>
          </ul>-->

          <div class="cases_box">
            <router-link tag="div" to="/casesDetail" class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_1.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>销售大神</h3>
                <p>销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息...</p>
              </div>
            </router-link>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_2.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/web_icon.png" alt />
                </div>
                <h3>行业解决方案</h3>
                <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的高技术企业。</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_3.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/hardware_icon.png" alt />
                </div>
                <h3>增氧机硬件设备</h3>
                <p>增氧机是一种常被应用于渔业养殖业的机器。它的主要作用是增加水中的氧气含量以确保水中的鱼类不会缺氧，同时也能抑制水中厌氧菌的生长...</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_4.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>奥沙渔业</h3>
                <p>奥沙渔业主要是研发水产养殖方面的物联网，包括三层结构：分别是软件系统（移动APP）、数据分析（数据文档）、硬件系统（物联网控制模块）。</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_5.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/web_icon.png" alt />
                </div>
                <h3>一毛共享</h3>
                <p>
                  一毛共享是一款集商业推广、网上购物于一体的，个性化电子海报智能分发平台。
                  <br />商家通过红包的形式投放自己的海报，让精准用户...
                </p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_6.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/hardware_icon.png" alt />
                </div>
                <h3>良境</h3>
                <p>“良境”是良境（深圳）网络科技有限公司开发的一款通过构建美陈、景观、装饰、灯光、花艺的空间设计行业垂直生态平台，满足行业内人士...</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_7.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>万物物联</h3>
                <p>万物物联也称智慧物联，主要指的是为所有硬件的联网，提供一整套系统性的解决方案。其应用范围覆盖了个人穿戴、家庭安防、智慧出行、智慧农业...</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_8.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>未来智能箱</h3>
                <p>未来智能箱是公司自主研发搭配智能模块，通过蓝牙通信技术、网路安全加密技术实现智能箱的定位功能、开箱功能可联网集中管理智能箱...</p>
              </div>
            </div>
            <div class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_9.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>赤商风采</h3>
                <p>为赤峰商会会员提供了信息交流的平台。每位注册用户可通过app设置自己旗下公司的信息，加入商会、收藏感兴趣的人，也可给自己设定个人风采。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.cases_banner {
  background: url("../assets/images/cases_banner.png") no-repeat;
  background-position: center;
  position: relative;
  top: 90px;
  margin-bottom: 90px;
  height: 500px;
  min-width: 1200px;
}
.home_item {
  .cases_flex {
    flex-direction: column;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 80px;
    position: relative;

    .cases_sort {
      position: absolute;
      display: flex;
      top: 30px;
      right: 0;
      li a {
        padding: 0 15px;
        font-size: 20px;
        line-height: 28px;
        //color:rgba(38,172,255,1);
      }
    }
    .home_item_content {
      margin-top: 200px;
      width: 500px;

      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
    }
    .cases_btn {
      position: absolute;
      right: 0;
      top: 141px;
      img {
        z-index: 10;
      }
      a {
        padding: 20px;
        background: rgba(38, 172, 255, 0.1);
      }
    }
    .cases_box {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      flex-wrap: wrap;
      .cases_item {
        width: 384px;
        height: 486px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
        opacity: 1;
        border-radius: 15px 15px 0px 0px;
        margin-bottom: 24px;
        &:hover {
          transform: translateY(-15px);
        }
        .cases_txt {
          padding: 50px 30px 0 30px;
          position: relative;
          .cases_icon {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: rgba(38, 172, 255, 1);
            border: 3px solid rgba(253, 252, 251, 1);
            position: absolute;
            top: -30px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          h3 {
            font-size: 20px;
            line-height: 25px;
            color: rgba(64, 64, 64, 1);
          }
          p {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 14px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>